import React, { ReactNode } from 'react'

import { DialogContainer } from './components/DialogContainer'
import { DialogContent } from './components/DialogContent'
import { DialogFooter } from './components/DialogFooter'
import { DialogHeader } from './components/DialogHeader'
import { DialogSubHeader } from './components/DialogSubHeader'
import { DialogVariant } from './types'

export interface DialogProps {
  children?: string | ReactNode
  Header?: string | ReactNode
  SubHeader?: string | ReactNode
  Footer?: ReactNode
  close?: () => void
  variant?: DialogVariant
  isOpen?: boolean
  className?: string
}

export function Dialog({
  children,
  Header,
  SubHeader,
  Footer,
  close,
  className,
  variant = 'default',
  isOpen = true,
}: DialogProps) {
  return (
    <DialogContainer
      variant={variant}
      condition={isOpen}
      close={close}
      className={className}
    >
      <DialogHeader
        condition={!!Header}
        Header={Header!}
        close={close}
      />
      <DialogSubHeader
        condition={!!SubHeader}
        SubHeader={SubHeader!}
      />
      <DialogContent>{children}</DialogContent>
      <DialogFooter>{Footer}</DialogFooter>
    </DialogContainer>
  )
}
